export type PlacesErrorType = 'sdk_load_error' | 'network_unavailable' | 'quota_exceeded' | 'init_error';

const QUOTA_SIGNALS = /OVER_QUERY_LIMIT|OVER_DAILY_LIMIT|429/;
const SDK_SIGNALS = /not defined|REQUEST_DENIED|ApiNotActivated|InvalidKey/;

export class PlacesError extends Error {
  constructor(public readonly type: PlacesErrorType, public readonly original: unknown) {
    super(`PlacesError[${type}]`);
    this.name = 'PlacesError';
  }
}

export function classifyPlacesError(err: unknown): PlacesErrorType {
  if (!navigator.onLine) return 'network_unavailable';
  const msg = (err as Error)?.message ?? String(err);
  if (QUOTA_SIGNALS.test(msg)) return 'quota_exceeded';
  if (SDK_SIGNALS.test(msg)) return 'sdk_load_error';
  return 'network_unavailable';
}

export function classifyPlacesInitError(err: unknown): PlacesErrorType {
  if (!navigator.onLine) return 'network_unavailable';
  const msg = (err as Error)?.message ?? String(err);
  if (SDK_SIGNALS.test(msg)) return 'sdk_load_error';
  if (/network|fetch|ERR_/i.test(msg)) return 'network_unavailable';
  return 'init_error';
}
